import { useState, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FiMail, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();

  /* Hide the shared Layout header/footer so the auth screen gets the same
     self-contained, branded shell as the new logged-out homepage. */
  useLayoutEffect(() => {
    document.body.classList.add('auth-active');
    return () => document.body.classList.remove('auth-active');
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      await resetPassword(email);
      setSuccess(true);
    } catch (err) {
      setError('Failed to send reset email. Please check the email address.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <Helmet>
        <title>Reset Password - TeachESLPro</title>
        <meta name="description" content="Reset your TeachESLPro account password. Enter your email to receive a password reset link." />
      </Helmet>


      <main className="auth-main">
        <div className="auth-shell">
          <div className="auth-head">
            <h1>Reset your <em>password</em></h1>
            <p>Enter your email and we&apos;ll send you a reset link</p>
          </div>

          <div className="auth-card">
            {error && (
              <div className="auth-error">
                <FiAlertCircle className="w-5 h-5" />
                <span>{error}</span>
              </div>
            )}

            {success && (
              <div className="auth-success">
                <FiCheckCircle className="w-5 h-5" />
                <span>Password reset email sent! Check your inbox.</span>
              </div>
            )}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-field">
                <label htmlFor="email" className="auth-label">Email address</label>
                <div className="auth-input-wrap">
                  <span className="auth-input-icon"><FiMail /></span>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="auth-input"
                    placeholder="you@example.com"
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="auth-btn auth-btn-primary auth-submit"
              >
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
            </form>

            <Link to="/login" className="auth-back">← Back to login</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ForgotPassword;
